import { Outlet } from "react-router-dom";

import { type SessionRecord } from "@/shared/domain/sessions";

import { SessionChrome } from "./SessionChrome";
import styles from "./SessionDetail.module.css";
import { type SessionOutletContext } from "./useSessionOutletContext";

interface SessionLayoutProps {
  /**
   * Resolved session record threaded in by ``SessionDetail``. Passed by
   * prop rather than re-queried here so the breadcrumb and body share
   * one ``useSession`` suspense throw.
   */
  session: SessionRecord;
}

/**
 * Loaded body of the session-detail page. Renders the shared
 * ``SessionChrome`` (title + metadata + tab bar) and publishes the
 * resolved record through React Router's ``Outlet`` context so child
 * tab routes can render without re-fetching.
 */
export function SessionLayout({ session }: SessionLayoutProps) {
  const outletContext: SessionOutletContext = { session };

  return (
    <div className={styles.root}>
      <SessionChrome sessionId={session.session_id} session={session} />

      <div className={styles.tabPanel}>
        <Outlet context={outletContext} />
      </div>
    </div>
  );
}
